export { default, type AdConfig, type BlogheradsAdProps } from './BlogheradsAd';
